import { render, staticRenderFns } from "./box-code-modal.vue?vue&type=template&id=c8a36d84"
import script from "./box-code-modal.vue?vue&type=script&lang=js"
export * from "./box-code-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports